import { Box, Card, Stack, SvgIcon, Typography } from "@mui/material";
import moment from "moment";
import CustomImageCarousal from "../components/CustomImageCarousal";
import InstagramLayout from "assets/icons1/instagram-layout.png";
import InstagramIcon from "@mui/icons-material/Instagram";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import instagramHeartIcon from "assets/icons1/insta-heart.png";
import instagramCommentIcon from "assets/icons1/insta-comment.png";
import instagramTagIcon from "assets/icons1/insta-tag.png";
import instagramSaveIcon from "assets/icons1/insta-save.png";
import { useContext } from "react";
import { SocialCampaignContext } from "../Context";
import { isTruthy } from "helpers/methods";

interface CustomProps {
  formFields: any;
  imageArray?: string[];
  carousalIndex?: number;
  setCarousalIndex?: Function;
}

const Instagram = (props: CustomProps) => {
  const { submitCampaign } = useContext(SocialCampaignContext);
  return (
    <Box width="450px">
      <Card
        sx={{
          p: 2,
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            {submitCampaign.profilePicture ? (
              <img
                src={submitCampaign.profilePicture}
                alt="Profile"
                width="40px"
              />
            ) : (
              <SvgIcon>
                <InstagramIcon fontSize="large" />
              </SvgIcon>
            )}

            <Stack direction="column">
              <Typography variant="body1">{submitCampaign.userName}</Typography>{" "}
              <Typography variant="body2">
                {moment().format("MMMM D, YYYY [at] h:mm A")}
              </Typography>
            </Stack>
          </Stack>
          <SvgIcon>
            <MoreVertIcon />
          </SvgIcon>
        </Stack>

        <Stack pt={1}>
          <CustomImageCarousal
            imageArray={props.imageArray}
            noImageLayout={InstagramLayout}
            displayImageIndex={props.carousalIndex}
            setDisplayImageIndex={props.setCarousalIndex}
          />
        </Stack>
        <Stack direction="row" pt={1} justifyContent="space-between">
          <Stack direction="row" spacing={1}>
            <Box>
              <img
                src={instagramHeartIcon}
                style={{ width: "15px", height: "auto" }}
                alt="icon"
              />
            </Box>
            <Box sx={{ width: "15px" }}>
              <img
                src={instagramCommentIcon}
                style={{ width: "15px", height: "auto" }}
                alt="icon"
              />
            </Box>

            <Box sx={{ width: "15px" }}>
              <img
                src={instagramTagIcon}
                style={{ width: "15px", height: "auto" }}
                alt="icon"
              />
            </Box>
          </Stack>
          <Stack>
            <img
              src={instagramSaveIcon}
              style={{ width: "15px", height: "auto" }}
              alt="icon"
            />
          </Stack>
        </Stack>
        <Stack pt={1}>
          <Typography
            variant="body2"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            <span style={{ fontWeight: 600 }}>{submitCampaign.userName}</span>{" "}
            {isTruthy(props.formFields.message.value)
              ? props.formFields.message.value
              : "publish Your Post On Instagram..."}
          </Typography>
        </Stack>
      </Card>
    </Box>
  );
};

export default Instagram;
